import { render, staticRenderFns } from "./AceitarTermos.vue?vue&type=template&id=737efb23"
import script from "./AceitarTermos.vue?vue&type=script&lang=ts"
export * from "./AceitarTermos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports